(function() {
    const debug = false;
    const onDocumentReady = function(callback) {
        if (document.readyState != 'loading') {
            if (typeof callback === 'function') callback();
        } else {
            document.addEventListener('DOMContentLoaded', () => {
                if (typeof callback === 'function') callback();
            });
        }
    };

    onDocumentReady(() => {
        let windowWidth = window.innerWidth;

        const stickyBranding = document.querySelector('[data-stick-on-section-number]');
        const stickyBrandingContent = document.querySelector('[data-stick-on-section-number] .mis__sticky-logo--inner');
        if(!stickyBranding) return;

        const sectionNumber = parseInt(stickyBranding.getAttribute('data-stick-on-section-number'));

        if(isNaN(sectionNumber)) return;
        if(sectionNumber < 1) return;

        const sections = document.querySelectorAll('#MainContent .shopify-section');
        if(sectionNumber > sections.length) return;

        const section = sections[sectionNumber - 1];
        if(!section) return;

        const getScrollY = () => window.visualViewport ? window.visualViewport.pageTop : window.scrollY;


        // Setup logo initial status
        const initialTop = stickyBranding.getBoundingClientRect().top + getScrollY();
        if(debug) console.log('initialTop:', initialTop);

        const updateSectionMeasurements = () => {
            if (debug) console.log('UPDATED SECTION MEASUREMENTS');

            const sectionRect = section.getBoundingClientRect();
            const sectionTop = sectionRect.top + getScrollY();
            const sectionHeight = section.offsetHeight;
            const sectionBottom = sectionTop + sectionHeight;
            if (debug) {
                console.log('sectionRect:', sectionRect);
                console.log('sectionTop:', sectionTop);
                console.log('sectionHeight:', sectionHeight);
                console.log('sectionBottom:', sectionBottom);
            }
            return { sectionTop, sectionHeight, sectionBottom };
        };

        const updateBrandingMeasurements = () => {
            if (debug) console.log('UPDATED BRANDING MEASUREMENTS');

            const brandingRect = stickyBranding.getBoundingClientRect();
            const brandingTop = brandingRect.top + getScrollY();
            const brandingHeight = stickyBranding.offsetHeight;
            const brandingBottom = brandingTop + brandingHeight;

            if(stickyBrandingContent) {
                stickyBrandingContent.style.marginTop = `calc((${Math.ceil(brandingHeight / 2)}px + var(--announcement-height)) * -1)`;
            }

            if (debug) {
                console.log('brandingRect:', brandingRect);
                console.log('brandingTop:', brandingTop);
                console.log('brandingHeight:', brandingHeight);
                console.log('brandingBottom:', brandingBottom);
            }
            return { brandingTop, brandingHeight, brandingBottom };
        };

        let { sectionTop, sectionHeight, sectionBottom } = updateSectionMeasurements();
        let { brandingTop, brandingHeight, brandingBottom } = updateBrandingMeasurements();
        const originalBrandingTop = brandingTop;

        // Setting the scroll event listener as passive to improved performance on mobile devices ⚡️
        window.addEventListener('scroll', stickyBrandingHandler, { passive: true });
        stickyBrandingHandler(true);

        stickyBranding.setAttribute('data-stick-on-ready', 'true');

        function stickyBrandingHandler(onFirstLoad = false) {
            window.requestAnimationFrame(() => {
                const scrollY = getScrollY();

                if(!debug) {
                    console.log('scrollY + brandingBottom:', scrollY + brandingBottom);
                    console.log('sectionBottom:', sectionBottom);
                }

                if ((scrollY + window.innerHeight) >= sectionBottom) {
                    // If already stuck, do nothing
                    if(stickyBranding.getAttribute('data-stick-on-status') === 'stuck') return;

                    stickyBranding.setAttribute('data-stick-on-status', 'stuck');
                    stickyBranding.style.position = 'absolute';
                    stickyBranding.style.top = `${sectionBottom - sectionHeight / 2}px`;
                } else {
                    if(!onFirstLoad) {
                        // If not stuck already, do nothing
                        if(stickyBranding.getAttribute('data-stick-on-status') !== 'stuck') return;
                    }

                    stickyBranding.setAttribute('data-stick-on-status', 'false');
                    stickyBranding.style.position = 'fixed';
                    stickyBranding.style.top = '';
                    stickyBranding.style.transform = 'translateZ(0)'; // Force GPU acceleration for smooth scrolling on mobile devices ⚡️
                }
            });
        }

        window.addEventListener('resize', () => {
            // Check if the window size has changed on mobile browsers, for FREAKING virtual keyboard compatibility! 🥱
            if(windowWidth === window.innerWidth) return;
            windowWidth = window.innerWidth;

            ({ sectionTop, sectionHeight, sectionBottom } = updateSectionMeasurements());
            ({ brandingTop, brandingHeight, brandingBottom } = updateBrandingMeasurements());
        });
    });
})();